import {
  IoLogIn,
  IoCall,
  IoSearchCircle,
  IoPersonCircleOutline,
  IoEye,
  IoEyeOff,
  IoClose,
  IoAddOutline,
  IoDownload,
  IoChevronBackCircleOutline,
  IoArrowForwardCircleOutline,
  IoChevronForwardCircleOutline,
} from "react-icons/io5";
import { FcInfo } from "react-icons/fc";
import { GrSearchAdvanced } from "react-icons/gr";
import { SiGoogleads } from "react-icons/si";
import { FaPeoplePulling, FaSquareWhatsapp } from "react-icons/fa6";
import { MdMarkEmailUnread, MdEmail, MdPhone, MdOutlineQuestionMark, MdOutlineSend, MdLockReset, MdOutlineVerified, MdImportExport } from "react-icons/md";
import { MdMobileFriendly, MdOutlineReduceCapacity } from "react-icons/md";
import { HiOutlineClipboardDocumentList } from "react-icons/hi2";
import {
  IoIosArrowDropdownCircle,
  IoIosArrowDropupCircle,
  IoMdAddCircle,
  IoMdAdd,
  IoMdLogIn,
} from "react-icons/io";
import { BiImport, BiSolidReport } from "react-icons/bi";
import { BsBrowserChrome } from "react-icons/bs";
import { TbLockExclamation, TbNotes } from "react-icons/tb";
import { CgNotes } from "react-icons/cg";
import { LuWorkflow } from "react-icons/lu";
import { MdPendingActions } from "react-icons/md";
import { TbReport } from "react-icons/tb";
import { BsMicrosoftTeams } from "react-icons/bs";
import { RiLockPasswordFill } from "react-icons/ri";
import { TiLockClosed } from "react-icons/ti";

const ICONS = {
  IoLogIn,
  IoCall,
  FcInfo,
  GrSearchAdvanced,
  SiGoogleads,
  FaSquareWhatsapp,
  MdMarkEmailUnread,
  MdMobileFriendly,
  HiOutlineClipboardDocumentList,
  IoIosArrowDropdownCircle,
  IoIosArrowDropupCircle,
  IoSearchCircle,
  IoMdAddCircle,
  BiImport,
  IoPersonCircleOutline,
  IoEye,
  IoEyeOff,
  MdEmail,
  MdPhone,
  BsBrowserChrome,
  TbNotes,
  IoClose,
  IoMdAdd,
  CgNotes,
  LuWorkflow,
  IoAddOutline,
  IoDownload,
  MdPendingActions,
  TbReport,
  BsMicrosoftTeams,
  RiLockPasswordFill,
  TiLockClosed,
  MdOutlineReduceCapacity,
  IoChevronBackCircleOutline,
  IoChevronForwardCircleOutline,
  IoMdLogIn,
  MdOutlineQuestionMark,
  MdOutlineSend,
  MdLockReset,
  TbLockExclamation,
  MdOutlineVerified,

  MdImportExport,

  BiSolidReport,
  FaPeoplePulling,

};

export default ICONS;
